import React, { useEffect } from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { WebPhoneProviderV4, useWebPhoneContextV4 } from '../../contexts/WebPhoneContextV4';
import { AuthProvider } from '../../contexts/AuthContext';
import WebPhoneStandaloneV4 from './WebPhoneStandaloneV4';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Inner component that has access to WebPhone context
const WebPhonePopupContent: React.FC = () => {
  const { callStatus } = useWebPhoneContextV4();

  useEffect(() => {
    // Set document title
    document.title = 'WebPhone V3';
  }, []);

  useEffect(() => {
    // Warn user on reload/close if there's an active call
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (callStatus === 'calling' || callStatus === 'ringing' || callStatus === 'in-call') {
        e.preventDefault();
        // Modern browsers show their own message, but we set returnValue anyway
        e.returnValue = 'Your call will be disconnected if you continue.';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [callStatus]);

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      <WebPhoneStandaloneV4 />
    </Box>
  );
};

const WebPhonePopupV3: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <WebPhoneProviderV4>
          <WebPhonePopupContent />
        </WebPhoneProviderV4>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default WebPhonePopupV3;
